/**
 * ページ下部ボタンメニュー
 */
// 外部モジュールをインポート
import React from "react";


interface FooterMenuProps {
  children: React.ReactNode;
  flexDirection?: string;
  height?: string;
  right?: string;
  bottom?: string;
}

/**
 * ページ下部ボタンメニュー
 */
class FooterMenu extends React.Component<FooterMenuProps> {
  /**
   * 描画処理
   * @returns ReactElement
   */
  render() {
    return (
      <React.Fragment>
        <div className="d-print-none" style={{height: this.props.height || "0px"}}></div>
        <div
          className="d-print-none"
          style={{
            display: "flex",
            flexDirection: this.props.flexDirection || "row",
            position: "fixed",
            bottom: "0",
            right: "0",
            paddingRight: this.props.right || "0px",
            paddingBottom: this.props.bottom || "0px"
          } as React.CSSProperties}
        >
          {this.props.children}
        </div>
      </React.Fragment>
    );
  }
}


export default FooterMenu;
